module.exports = __webpack_public_path__ + "ed957442a91096965e76145e0e3fb3b3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-120.png
// module id = 109
// module chunks = 0